/* eslint-disable */
import React, { useEffect } from "react";
import {
    Divider,
    Box,
    Typography,
    Button,
    Stack,
    Grid,
    TextField,
    Backdrop
    // FormControl,
    // RadioGroup,
    // FormControlLabel,
    // FormHelperText,
    // Radio,
} from "@mui/material";
import { updateModuleState } from '../../stores/eventStore';
import Title from '../../sharedcomponents/title/title';
import InputMask from 'react-input-mask';
import ParticipantAutoList from '../../sharedcomponents/participantAutoList/participantAutoList';
import ApiHelper from '../../utility/ApiHelper';
import APIURLConstants from '../../config/config';
import AppConstants from '../../constants/appConstants';
import Helper from '../../utility/helper';
import { useState, createState, Downgraded } from '@hookstate/core';
import { useEventState } from "../../stores/eventStore";
import { FULL_PERMISSION, VIEW_PERMISSION } from "../../constants/Constant";
import validator from 'validator';
import CustomizedSnackbars from "../../sharedcomponents/snackbar/snackBar";
import RouteConstants from "../../constants/routeConstants";
import { generatePath, useHistory, useParams } from "react-router-dom";
import { useAgentState } from '../../hookState/AgentState';
import {
    useAgentSaveAsDraftState, setAgentShowConfirmPopUp, resetSaveAsDraftState
} from '../../hookState/AgentSaveAsDraftState';
import DetailsComponent from '../../sharedcomponents/detailsComponent/DetailsComponent';
import PhoneNumber from "../../sharedcomponents/PhoneNumber/phoneNumber";
import CircularProgress from '@mui/material/CircularProgress';
import { RouterPrompt } from '../../router/routerPrompt';
import { changeAgentUserHandler } from '../../utility/agentChangeUtility';

const vipState = createState({
    VIPID: 0,
    guestList: [],
    firstguest: '',
    secondguest: '',
    thirdguest: '',
    fourthguest: '',
    fifthguest: '',
    contactName: '',
    contactNo: '',
    contactEmail: '',
    photo: '',
    status: 0
});
const CreateVipExperience = () => {
    const state = useState(vipState);
    const history = useHistory()
    const eventState = useEventState();
    const agentSaveAsDraftState = useAgentSaveAsDraftState();
    const [autoApprove, setAutoApprove] = React.useState(0);
    const [participantList, setParticipantList] = React.useState(null);
    const [participant, setParticipant] = React.useState(null);
    const [participantNameErr, setParticipantNameErr] = React.useState('');
    const [partiErrorState, setPartiErrorState] = React.useState(false);
    const [modPermission, setModPermission] = React.useState(null);
    const [nameErr, setNameErr] = React.useState('');
    const [firstGErr, setFirstGErr] = React.useState('');
    const [secondGErr, setSecondGErr] = React.useState('');
    const [thirdGErr, setThirdGErr] = React.useState('');
    const [fourthGErr, setFourthGErr] = React.useState('');
    const [fifthGErr, setFifthGErr] = React.useState('');
    const [emailErr, setEmailErr] = React.useState('');
    const [phoneErr, setPhoneErr] = React.useState('');
    const agentInfo = Helper.getStorage('agentUser') ? Helper.getStorage('agentUser') : Helper.getSessionStorage('agentUser');
    const userInfo = agentInfo ? agentInfo : Helper.getStorage('userInfo');
    // const userInfo = Helper.getStorage('userInfo');
    const eventInfo = Helper.getStorage('eventInfo');
    // const agentInfo = Helper.getSessionStorage('agentUser');
    const [disableBtn, setDisableBtn] = React.useState(true);
    const [disableDraftBtn, setDisableDraftBtn] = React.useState(true);
    let params = useParams();
    // const [photoErr, setPhotoErr] = React.useState('');
    const agentState = useAgentState();
    const [showDetails, setShowDetails] = React.useState(false);
    const [showDetailData, setShowDetailData] = React.useState('');
    const [prevVipInfo, setPrevVipInfo] = React.useState()
    const [loading, setLoading] = React.useState(false);
    const [snackBarProps, setSnackBarProps] = React.useState({
        openSnack: false,
        variant: 'error',
        message: '',
    });
    const [showSaveAsDraftBtn, setShowSaveAsDraftBtn] = React.useState(false);
    const [saveAsDraftLoader, setSaveAsDraftLoader] = React.useState(false);
    const [openBackdrop, setOpenBackDrop] = React.useState(false);
    const [dirty, setDirty] = React.useState(false);
    const regex = new RegExp('[^\\s]+')
    let guestListArray = [
        {
            guestID: 0,
            vipid: 0,
            name: '',
            relationship: "Self",
            preDraftPicture: false

        }, {
            guestID: 0,
            vipid: 0,
            name: '',
            relationship: "Self",
            preDraftPicture: false

        }, {
            guestID: 0,
            vipid: 0,
            name: '',
            relationship: "Self",
            preDraftPicture: false

        }, {
            guestID: 0,
            vipid: 0,
            name: '',
            relationship: "Self",
            preDraftPicture: false

        }, {
            guestID: 0,
            vipid: 0,
            name: '',
            relationship: "Self",
            preDraftPicture: false

        }
    ];
    useEffect(() => {
        ApiHelper.get(APIURLConstants.GET_EVENT_MODULES(eventInfo.eventID, 1, false))
            .then((res) => {
                if (res.data) {
                    res.data.map((auto) => {
                        if (auto.moduleName === "VIP") {
                            setAutoApprove(auto.autoApprove)
                        }
                    })
                }
            })
    }, [])
    useEffect(() => {
        if (eventState.eventDetail.get() !== null) {
            const index = eventState.eventDetail
                .get()
                .moduleDetails?.findIndex((element) => {
                    if (element.moduleName === 'VIP') {
                        return true;
                    }
                });
            const userInfo = Helper.getStorage('userInfo');

            if (!Helper.isAdminUser(userInfo)) {
                if (
                    eventState.eventDetail.get() &&
                    ((index > 0 &&
                        eventState.eventDetail.get().moduleDetails[index]
                            ?.details !== null) ||
                        eventState.eventDetail.get().moduleDetails[index]
                            ?.details !== '')
                ) {
                    setShowDetails(true);
                    setShowDetailData(
                        eventState.eventDetail.get().moduleDetails[index]
                            ?.details
                    );
                } else {
                    setShowDetails(false);
                    setShowDetailData('');
                }
            }
            if (!Helper.isAdminUser(userInfo) || !Helper.isEventAdmin(userInfo) || !Helper.isEventStaff(userInfo)) {
                let modulePermission = eventState.attach(Downgraded).get().permissions &&
                    eventState.attach(Downgraded).get().permissions.length > 0 && eventState.attach(Downgraded).get().permissions.filter(item => item.module === "VIP");
                if (modulePermission != undefined && modulePermission.length > 0 && modulePermission[0].permission === "VIEW") {
                    setModPermission(VIEW_PERMISSION);
                } else {
                    setModPermission(FULL_PERMISSION)
                }
            }
            else {
                setModPermission(FULL_PERMISSION);
            }
            const gAgentInfo = Helper.getSessionStorage('agentUser');
            let showSaveDraft = false;
            const allModules = eventState.moduleState.get() !== null ? eventState.moduleState.get().find(i => i.requestStatus === 'To Do') : null;
            const isInTodo = allModules ? allModules.modules.some(m => m.module === 'VIP') : false;
            //show save as draft button for end User and Agent screen
            if (isInTodo && !Helper.isAdminUser(userInfo) && !Helper.isEventStaff(userInfo) && !Helper.isEventAdmin(userInfo)) {
                showSaveDraft = true;
            }
            else if (isInTodo && gAgentInfo &&
                !(Helper.isAdminUser(gAgentInfo) ||
                    (gAgentInfo.roles && Helper.isEventAdmin(gAgentInfo))) &&
                !(gAgentInfo.roles && Helper.isEventStaff(gAgentInfo))
            ) {
                showSaveDraft = true;
            }

            setShowSaveAsDraftBtn(showSaveDraft);
        }
    }, [eventState]);

    useEffect(() => {
        if (modPermission && modPermission == FULL_PERMISSION) {
            GetAdminEventParticipant(
                eventInfo,
                userInfo.userID
            )
        }
    }, [modPermission]);

    useEffect(() => {
        if (showSaveAsDraftBtn && modPermission && modPermission !== VIEW_PERMISSION) {
            setDirty(agentSaveAsDraftState.showConfirmPopUp.get());
        }
        else {
            setDirty(false);
        }

    }, [agentSaveAsDraftState, showSaveAsDraftBtn, modPermission])

    useEffect(() => {
        if (params.vipID) {
            const editVipState = history.location.state.vipState;
            const index = participantList && participantList.findIndex(
                (user) => user.userID == editVipState.userID
            );
            if (index != null && index > -1) {
                setParticipant(participantList[index]);
            }
            state.set({
                VIPID: editVipState.vipid,
                contactName: editVipState.contactName,
                contactNo: editVipState.contactCellNo,
                contactEmail: editVipState.contactEmail,
                photo: editVipState.isPhoto === true ? 'Yes' : 'No',
                status: editVipState.status,
                firstguest: editVipState.guest1 !== null ? editVipState.guest1 : '',
                secondguest: editVipState.guest2 !== null ? editVipState.guest2 : '',
                thirdguest: editVipState.guest3 !== null ? editVipState.guest3 : '',
                fourthguest: editVipState.guest4 !== null ? editVipState.guest4 : '',
                fifthguest: editVipState.guest5 !== null ? editVipState.guest5 : '',
            });
            setPrevVipInfo({
                VIPID: editVipState.vipid,
                contactName: editVipState.contactName,
                contactNo: editVipState.contactCellNo,
                contactEmail: editVipState.contactEmail,
                isPhoto: editVipState.isPhoto,
                status: editVipState.status,
                firstguest: editVipState.guest1 !== null ? editVipState.guest1 : '',
                secondguest: editVipState.guest2 !== null ? editVipState.guest2 : '',
                thirdguest: editVipState.guest3 !== null ? editVipState.guest3 : '',
                fourthguest: editVipState.guest4 !== null ? editVipState.guest4 : '',
                fifthguest: editVipState.guest5 !== null ? editVipState.guest5 : '',
            })
            setDisableBtn(true)
        }
        else {
            resetState();
            setParticipant(null)
            //setDisableBtn(false)
        }

    }, [participantList != null])

    useEffect(() => {

        let vipState = history.location.state && history.location.state.vipState ? history.location.state.vipState : null
        if (!params.vipID && !vipState) {
            getVipInfo();
        }
    }, [participantList != null])

    const changeParticipant = (participant) => {
        if (participant) {
            setPartiErrorState(false);
            setParticipantNameErr('');
        } else {
            setPartiErrorState(true);
            setParticipantNameErr('Please Select Participant');
        }
        setParticipant(participant);
    };

    const GetAdminEventParticipant = (gEventInfo, userId) => {
        ApiHelper.get(
            APIURLConstants.GET_ADMIN_EVENT_PARTICIPANTS(gEventInfo.eventID)
        ).then((res) => {
            if (res.data.rows) {
                const participants = res.data.rows.filter(
                    (participant) =>
                        AppConstants.EVENT_ROLES_VALUES.indexOf(
                            participant.roleName
                        ) == -1
                );
                if (!params.vipID) {
                    let users = history.location.state ? history.location.state.participantList : participants
                    setParticipantList(users);
                    //setDisableBtn(false);
                } else {
                    setParticipantList(participants);
                }

                const index = participants.findIndex(
                    (user) => user.userID == userId
                );
                if (index > -1) {
                    setParticipant(participants[index]);
                }
            }
        });
    };
    // const SETEmailNotification = (ObjRequest) =>
    // {
    //     // let obj = {
    //     //     vipid: ObjRequest.vipid,
    //     //     userID: ObjRequest.userID,
    //     //     eventID: ObjRequest.eventID,
    //     //     contactName: ObjRequest.contactName,
    //     //     contactCellNo: ObjRequest.contactCellNo,
    //     //     contactEmail: ObjRequest.contactEmail,
    //     //     isPhoto: true,
    //     //     participant: "heloo",
    //     //     submittedBy: "me",
    //     //     requestStatus: "Pending",
    //     //     auditStatus: "Pending",
    //     //     email: "achvamsikr@gmail.com",
    //     //     status: 1,
    //     //     note: "Pending",
    //     //     createdBy: userInfo.userID,
    //     //     createdByName: "string",
    //     //     createdDate: ObjRequest.createdDate,
    //     //     submittedDate: new Date(),
    //     //     vipGuestList: "string",
    //     //     vipAuditID: 0,
    //     //     guestList: ObjRequest.guestList
    //     // }
    //     return ApiHelper.post(
    //         APIURLConstants.POST_SET_VIP_EMAIL_NOTIFICATION,
    //         ObjRequest
    //     )
    //         .then((result) =>
    //         {
    //             return result.data;
    //         })
    //         .catch((err) =>
    //         {
    //             console.log(err);
    //         });
    // };
    const getVipInfo = () => {
        const gAgentInfo = Helper.getSessionStorage('agentUser');
        const agentConnection = Helper.getSessionStorage('agentConnections');
        ApiHelper.get(APIURLConstants.GET_VIP_INFO(eventInfo.eventID, agentConnection && gAgentInfo ? gAgentInfo.userID : userInfo.userID)).then(res => {
            let info = res.data.rows[0];
            if (info) {
                const index = participantList && participantList.findIndex(
                    (user) => user.userID == info.userID
                );
                if (index != null && index > -1) {
                    setParticipant(participantList[index]);
                }
                state.set({
                    VIPID: info.vipid,
                    contactName: info.contactName,
                    contactNo: info.contactCellNo,
                    contactEmail: info.contactEmail,
                    status: info.status,
                    firstguest: info.guest1 ? info.guest1 : '',
                    secondguest: info.guest2 ? info.guest2 : '',
                    thirdguest: info.guest3 ? info.guest3 : '',
                    fourthguest: info.guest4 ? info.guest4 : '',
                    fifthguest: info.guest5 ? info.guest5 : '',
                    // photo: info.isPhoto === true ? 'Yes' : 'No'
                })
                let obj = {
                    VIPID: info.vipid,
                    contactName: info.contactName,
                    contactNo: info.contactCellNo,
                    contactEmail: info.contactEmail,
                    status: info.status,
                    firstguest: info.guest1 ? info.guest1 : '',
                    secondguest: info.guest2 ? info.guest2 : '',
                    thirdguest: info.guest3 ? info.guest3 : '',
                    fourthguest: info.guest4 ? info.guest4 : '',
                    fifthguest: info.guest5 ? info.guest5 : '',
                }
                setPrevVipInfo(obj)
                if (info.status === 0) {
                    setDisableBtn(false);
                }
                else {
                    setDisableBtn(true);
                }

            } else {
                setDisableBtn(false);
                resetState()
            }

        }).catch(err => {
            console.log(err);
        })
    }
    const validateContactName = () => {
        let value = state.contactName.get().trim();
        if (value == '') {
            setNameErr('Please Enter Contact Name');
        } else {
            if (Helper.onlyLettersAndSpaces(value)) {
                setNameErr('');
                return true;
            } else setNameErr('Please Enter Valid Contact Name');
        }
    };
    const validateFirstG = () => {
        let value = state.firstguest.get().trim();
        if (value === '') {
            setFirstGErr('')
            return true
        } else if (Helper.onlyLettersAndSpaces(value)) {
            setFirstGErr('');
            return true;
        } else setFirstGErr('Please Enter Valid First Guest Name');
    };
    const validateSecondG = () => {
        let value = state.secondguest.get().trim();
        if (value === '') {
            setSecondGErr('')
            return true
        } else if (Helper.onlyLettersAndSpaces(value)) {
            setSecondGErr('');
            return true;
        } else setSecondGErr('Please Enter Valid Second Guest Name');
    }; const validateThirdG = () => {
        let value = state.thirdguest.get().trim();
        if (value === '') {
            setThirdGErr('')
            return true
        } else if (Helper.onlyLettersAndSpaces(value)) {
            setThirdGErr('');
            return true;
        } else setThirdGErr('Please Enter Valid Third Guest Name');
    }; const validateFourthG = () => {
        let value = state.fourthguest.get().trim();
        if (value === '') {
            setFourthGErr('')
            return true
        } else if (Helper.onlyLettersAndSpaces(value)) {
            setFourthGErr('');
            return true;
        } else setFourthGErr('Please Enter Valid Fourth Guest Name');
    }; const validateFifthG = () => {
        let value = state.fifthguest.get().trim();
        if (value === '') {
            setFifthGErr('')
            return true
        } else if (Helper.onlyLettersAndSpaces(value)) {
            setFifthGErr('');
            return true;
        } else setFifthGErr('Please Enter Valid Fifth Guest Name');
    };
    const validateEmail = () => {
        let value = state.contactEmail.get().trim();
        if (value == '') {
            setEmailErr('Please enter emailid');
            return true;
        }
        if (validator.isEmail(value)) {
            setEmailErr('');
            return true;
        } else {
            setEmailErr('Please enter valid emailid');
            return false;
        }
    };
    // const handlePhotoChange = (e) =>
    // {
    //     let value = state.photo.set(e.target.value)
    //     if (value === null || value === "")
    //     {
    //         setPhotoErr('Please select photo')
    //     } else
    //     { setPhotoErr('') }
    //     handleDisableBtn()
    // }
    const checkValidPhone = () => {
        const phone = state.contactNo.get();
        console.log("phone", phone);
        if (phone === "" || phone === "1") {
            setPhoneErr('please enter contact number');
        } else {
            setPhoneErr('');
        }
    };
    // const onChangePhone = (val) => {
    //     // console.log(val);
    //     state.contactNo.set(val);
    //     handleDisableBtn();
    // }
    const handleSubmit = (event) => {
        event.preventDefault();
        setLoading(true);
        setDisableBtn(true);
        // if (Helper.isAdminUser(userInfo) || userInfo.roles && Helper.isEventAdmin(userInfo))
        // {
        // console.log("participant",participant);
        if ((participant === null) && ((Helper.isEventAdmin(userInfo) || Helper.isAdminUser(userInfo)))) {
            setLoading(false);
            setPartiErrorState(true);
            setParticipantNameErr('Please Select Participant');
            return false;
        }
        else if (state.contactNo.get() === "" || state.contactNo.get() === "1") {
            setLoading(false);
            setPhoneErr('please enter contact number');
            return false;
        }
        else if (nameErr.length > 0 || emailErr.length > 0 || firstGErr.length > 0 || secondGErr.length > 0 || thirdGErr.length > 0 || fourthGErr.length > 0 || fifthGErr.length > 0) {
            return false
        }
        // else if (state.photo.get() === undefined)
        // {
        //     setPhotoErr('Please select photo')
        //     return false
        // } 
        else {
            guestListArray.map((item, index) => {
                if (state.get().firstguest) {
                    index == 0 ? item.name = state.get().firstguest : ''
                } if (state.get().secondguest) {
                    index == 1 ? item.name = state.get().secondguest : ''
                } if (state.get().thirdguest) {
                    index == 2 ? item.name = state.get().thirdguest : ''
                } if (state.get().fourthguest) {
                    index == 3 ? item.name = state.get().fourthguest : ''
                } if (state.get().fifthguest) {
                    index == 4 ? item.name = state.get().fifthguest : ''
                }
            })

            let editedGuestList = [];
            guestListArray.map(item => item.name != '' && editedGuestList.push(item))
            if (editedGuestList.length == 0) {
                setLoading(false);
                setSnackBarProps({
                    openSnack: true,
                    variant: 'error',
                    message: 'Please Enter atleast one Guest',
                });
            } else {
                postVIPdata();
            }
        }
    }
    const resetState = () => {
        let info = {
            participantname: '',
            VIPID: 0,
            guestList: [],
            firstguest: '',
            secondguest: '',
            thirdguest: '',
            fourthguest: '',
            fifthguest: '',
            contactName: '',
            contactNo: '',
            contactEmail: '',
            status: 0
        }
        state.set(info);
        let prevData = {
            contactName: info.contactName,
            contactNo: info.contactNo,
            contactEmail: info.contactEmail,
            // photo: info.isPhoto === true ? 'Yes' : 'No',
            firstguest: info.firstguest,
            secondguest: info.secondguest,
            thirdguest: info.thirdguest,
            fourthguest: info.fourthguest,
            fifthguest: info.fifthguest
        }
        setPrevVipInfo(JSON.parse(JSON.stringify(prevData)));
        resetSaveAsDraftState();
    }

    const postVIPdata = (isDraft = false) => {
        setDisableDraftBtn(true);
        let requestObj = generateRequestObj(isDraft);
        ApiHelper.post(APIURLConstants.POST_VIP, requestObj).then(res => {
            setSaveAsDraftLoader(false);
            resetSaveAsDraftState();
            setLoading(false);
            if (res.data > 0) {

                let message = isDraft ? 'Form Saved successfully'
                    : state.get().VIPID > 0 && !showSaveAsDraftBtn ? 'Form Updated successfully' : 'Form Submitted successfully'
                // if (requestObj.vipid !== 0 || autoApprove === 1)
                // {
                // SETEmailNotification(requestObj);
                // }

                if (!isDraft) {
                    setShowSaveAsDraftBtn(false);
                    setTimeout(() => {

                        if (Helper.isAdminUser(userInfo) ||
                            (userInfo.roles && Helper.isEventAdmin(userInfo)) || (userInfo.roles && Helper.isEventStaff(userInfo))) {

                            history.push(generatePath(RouteConstants.EVENT_VIP, {
                                eventID: eventInfo.eventID,
                            }))
                        } else {
                            history.push(generatePath(RouteConstants.EVENT_DETAIL, {
                                eventID: eventInfo.eventID,
                            }))
                            resetState();
                            setParticipant(null);
                            getVipInfo();
                            updateModuleState()
                        }
                    }, 1000);
                }
                else {
                    getVipInfo();
                    setDisableBtn(false);
                    // updateModuleState();
                }

                setSnackBarProps({
                    openSnack: true,
                    variant: 'success',
                    message: message,
                })
            } else {
                setSnackBarProps({
                    openSnack: true,
                    variant: 'error',
                    message: 'Something went wrong',
                })
            }
        }).catch(err => {
            if (isDraft) {
                setDisableBtn(false);
            }
            setLoading(false);
            setSaveAsDraftLoader(false);
            console.log(err);
        })

    }

    const handleCancel = () => {
        setLoading(false);
        history.push(
            generatePath(RouteConstants.EVENT_VIP, {
                eventID: eventInfo.eventID,
            })
        )
    }
    const handleDisableBtn = () => {

        if (prevVipInfo != undefined) {
            const info = prevVipInfo;
            let prevData = {
                contactName: info.contactName,
                contactNo: info.contactNo,
                contactEmail: info.contactEmail,
                // photo: info.isPhoto === true ? 'Yes' : 'No',
                firstguest: info.firstguest,
                secondguest: info.secondguest,
                thirdguest: info.thirdguest,
                fourthguest: info.fourthguest,
                fifthguest: info.fifthguest
            }
            let currentData = {
                contactName: state.get().contactName,
                contactNo: state.get().contactNo,
                contactEmail: state.get().contactEmail,
                // photo: state.get().photo,
                firstguest: state.get().firstguest,
                secondguest: state.get().secondguest,
                thirdguest: state.get().thirdguest,
                fourthguest: state.get().fourthguest,
                fifthguest: state.get().fifthguest
            }
            if (JSON.stringify(prevData) === JSON.stringify(currentData)) {
                setAgentShowConfirmPopUp(false);
                if (state.get().status === 1) {
                    setDisableBtn(true);
                }
                setDisableDraftBtn(true);
            } else {
                if (showSaveAsDraftBtn) {
                    setAgentShowConfirmPopUp(true);
                }
                setDisableBtn(false);
                setDisableDraftBtn(false);
            }
        }

    }

    const handleSaveAsDraft = () => {
        setDisableBtn(true);
        setSaveAsDraftLoader(true);
        postVIPdata(true);
    }

    const generateRequestObj = (isDraft = false) => {
        let requestObj = {
            vipid: state.get().VIPID,
            userID: (Helper.isEventAdmin(agentInfo) || Helper.isAdminUser(agentInfo)) ? participant
                && participant.userID : agentState.visible.value
                ? agentInfo.userID
                : participant
                    ? participant.userID
                    : userInfo.userID,
            eventID: eventInfo.eventID,
            contactName: state.contactName.get(),
            contactEmail: state.contactEmail.get(),
            contactCellNo: state.contactNo.get(),
            isPhoto: state.photo.get() === 'Yes' ? true : false,
            status: autoApprove === 1 ? 2 : 1,
            createdBy: JSON.stringify(Helper.getStorage('userInfo').userID),
            createdDate: Helper.FormatDateWithTime(new Date()),
            guest1: state.get().firstguest,
            guest2: state.get().secondguest,
            guest3: state.get().thirdguest,
            guest4: state.get().fourthguest,
            guest5: state.get().fifthguest,
            isDraft: isDraft
        }
        return requestObj;
    }

    const handleSaveAsDraftOnPromptConfirm = () => {
        return new Promise((resolve, reject) => {
            let Obj = generateRequestObj(true);
            setOpenBackDrop(true);
            setDisableBtn(true);
            setDisableDraftBtn(true);
            ApiHelper.post(APIURLConstants.POST_VIP, Obj)
                .then((res) => {
                    setDisableBtn(false);
                    setOpenBackDrop(false);
                    if (res.status === 200) {
                        //below code is added to check to show save as draft pop up in case of agent dropdown
                        if (agentSaveAsDraftState.showConfirmPopUp.get() && agentSaveAsDraftState.agentUserInfo.get()) {
                            changeAgentUserHandler(agentSaveAsDraftState.agentUserInfo.get(), agentSaveAsDraftState.userEvents.get());
                        }
                        else {
                            getVipInfo();
                            updateModuleState();
                            resetSaveAsDraftState();
                        }
                        resolve(true);
                    }
                })
                .catch((error) => {
                    setOpenBackDrop(false);
                    setDisableBtn(false);
                    showErrorSnackBar(error);
                    resetSaveAsDraftState();
                    reject(false);
                });
        })
    }

    const handleCancelConfirmation = () => {
        //below code is added to check to show save as draft pop up in case of agent dropdown
        if (agentSaveAsDraftState.showConfirmPopUp.get() && agentSaveAsDraftState.agentUserInfo.get()) {
            changeAgentUserHandler(agentSaveAsDraftState.agentUserInfo.get(), agentSaveAsDraftState.userEvents.get());
        }

        return true;
    }

    // console.log("state.get()",agentInfo && (Helper.isAdminUser(agentInfo) ||
    // (agentInfo.roles && Helper.isEventAdmin(agentInfo)) || (agentInfo.roles && Helper.isEventStaff(agentInfo))), !agentInfo && (Helper.isAdminUser(userInfo) ||
    // (userInfo.roles && Helper.isEventAdmin(userInfo)) || (userInfo.roles && Helper.isEventStaff(userInfo)))); 
    return (
        < >
            <Box
                sx={{
                    maxHeight: 'calc(100vh - 70px)',
                    overflowY: 'auto',

                }}
                className="contentBox"
                style={{ paddingLeft: '24px', paddingRight: '24px' }}>
                <Box component={'form'} onSubmit={handleSubmit}>
                    <Title title={Helper.getModuleName(eventInfo ? eventInfo.moduleDetails : [],
                        AppConstants.EVENT_MODULES.VIP)} />
                    {showDetails ? (
                        <DetailsComponent data={showDetailData} />
                    ) : null}
                    <Box component="div">
                        <Box sx={{ width: '100%' }}>
                            <Grid
                                container
                                rowSpacing={2}
                                columnSpacing={{ xs: 1, sm: 2, md: 3 }}>
                                <Grid item container >
                                    <Grid item md={4}>
                                    </Grid>
                                    <Grid item xs={12} md={4} >
                                        {agentInfo && (Helper.isAdminUser(agentInfo) ||
                                            (agentInfo.roles && Helper.isEventAdmin(agentInfo)) || (agentInfo.roles && Helper.isEventStaff(agentInfo))) ?
                                            <ParticipantAutoList
                                                participant={participant}
                                                setParticipant={changeParticipant}
                                                participantList={participantList}
                                                modPermission={modPermission}
                                                error={partiErrorState}
                                                errorText={participantNameErr}
                                                disableParticipant={history.location.state && history.location.state.vipState ? true : false}
                                            /> :
                                            (!agentInfo && (Helper.isAdminUser(userInfo) ||
                                                (userInfo.roles && Helper.isEventAdmin(userInfo)) || (userInfo.roles && Helper.isEventStaff(userInfo)))) ?
                                                <ParticipantAutoList
                                                    participant={participant}
                                                    setParticipant={changeParticipant}
                                                    participantList={participantList}
                                                    modPermission={modPermission}
                                                    error={partiErrorState}
                                                    errorText={participantNameErr}
                                                    disableParticipant={history.location.state && history.location.state.vipState ? true : false}
                                                />
                                                : null
                                            // <TextField
                                            //     size="small"
                                            //     value={participant && participant.name}
                                            //     fullWidth
                                            //     id="outlined-basic"
                                            //     variant="outlined"
                                            //     disabled={true}
                                            // />
                                        }
                                    </Grid>
                                    <Grid item md={4}>
                                    </Grid>
                                </Grid>
                                <Grid item lg={6} md={6} xs={12}>
                                    <Box component="div" sx={{ mt: 2, mb: 2 }}>
                                        <TextField
                                            size="small"
                                            label="First Guest"
                                            fullWidth
                                            id="outlined-basic"
                                            variant="outlined"
                                            inputProps={{ maxLength: 50 }}
                                            value={state.firstguest.get()}
                                            onChange={(event) => {
                                                regex.test(event.target.value)
                                                    ? state.firstguest.set(event.target.value)
                                                    : state.firstguest.set(event.target.value.trim());
                                                validateFirstG();
                                                handleDisableBtn();
                                            }}
                                            error={firstGErr.length > 0 ? true : false}
                                            helperText={
                                                firstGErr.length > 0 ? firstGErr : ''
                                            }
                                        />
                                    </Box>
                                    <Box component="div" sx={{ mt: 2, mb: 2 }}>
                                        <TextField
                                            size="small"
                                            fullWidth
                                            label="Second Guest"
                                            id="outlined-basic"
                                            variant="outlined"
                                            inputProps={{ maxLength: 50 }}
                                            value={state.secondguest.get()}
                                            onChange={(event) => {
                                                regex.test(event.target.value)
                                                    ? state.secondguest.set(event.target.value)
                                                    : state.secondguest.set(event.target.value.trim());
                                                validateSecondG();
                                                handleDisableBtn();
                                            }}
                                            error={secondGErr.length > 0 ? true : false}
                                            helperText={
                                                secondGErr.length > 0 ? secondGErr : ''
                                            }
                                        />
                                    </Box>
                                    <Box component="div" sx={{ mt: 2, mb: 2 }}>
                                        <TextField
                                            size="small"
                                            label="Third Guest"
                                            fullWidth
                                            minRows={2}
                                            id="outlined-basic"
                                            variant="outlined"
                                            inputProps={{ maxLength: 50 }}
                                            value={state.thirdguest.get()}
                                            onChange={(event) => {
                                                regex.test(event.target.value)
                                                    ? state.thirdguest.set(event.target.value)
                                                    : state.thirdguest.set(event.target.value.trim());
                                                validateThirdG();
                                                handleDisableBtn();
                                            }}
                                            error={thirdGErr.length > 0 ? true : false}
                                            helperText={
                                                thirdGErr.length > 0 ? thirdGErr : ''
                                            }
                                        />
                                    </Box>
                                    <Box component="div" sx={{ mt: 2, mb: 2 }}>

                                        <TextField
                                            size="small"
                                            fullWidth
                                            label="Fourth Guest"
                                            id="outlined-basic"
                                            variant="outlined"
                                            inputProps={{ maxLength: 50 }}
                                            value={state.fourthguest.get()}
                                            onChange={(event) => {
                                                regex.test(event.target.value)
                                                    ? state.fourthguest.set(event.target.value)
                                                    : state.fourthguest.set(event.target.value.trim());
                                                validateFourthG();
                                                handleDisableBtn();
                                            }}
                                            error={fourthGErr.length > 0 ? true : false}
                                            helperText={
                                                fourthGErr.length > 0 ? fourthGErr : ''
                                            }
                                        />
                                    </Box>
                                    <Box component="div" sx={{ mt: 2, mb: 2 }}>

                                        <TextField
                                            size="small"
                                            label="Fifth Guest"
                                            fullWidth
                                            minRows={2}
                                            id="outlined-basic"
                                            variant="outlined"
                                            inputProps={{ maxLength: 50 }}
                                            value={state.fifthguest.get()}
                                            onChange={(event) => {
                                                regex.test(event.target.value)
                                                    ? state.fifthguest.set(event.target.value)
                                                    : state.fifthguest.set(event.target.value.trim());
                                                validateFifthG();
                                                handleDisableBtn();
                                            }}
                                            error={fifthGErr.length > 0 ? true : false}
                                            helperText={
                                                fifthGErr.length > 0 ? fifthGErr : ''
                                            }
                                        />
                                    </Box>
                                </Grid>
                            </Grid>
                        </Box>
                        <Divider
                            light={false}
                            sx={{ mt: 2, marginRight: 0, mb: 2 }}
                            flexItem
                        />
                        <Box component='div' sx={{ width: '100%' }}>
                            <Typography fontWeight={600} sx={{ mb: 2 }}>
                                Guest Contact Details
                            </Typography>
                            <Grid
                                container
                                rowSpacing={2}
                                columnSpacing={{ xs: 1, sm: 2, md: 3 }}>
                                <Grid item lg={4} md={4} xs={12}>
                                    <TextField
                                        fullWidth
                                        size="small"
                                        id="outlined-basic"
                                        variant="outlined"
                                        label="Contact Name"
                                        required
                                        value={state.contactName.get()}
                                        onChange={(event) => {
                                            regex.test(event.target.value)
                                                ? state.contactName.set(event.target.value)
                                                : state.contactName.set(event.target.value.trim());
                                            validateContactName();
                                            handleDisableBtn();
                                        }}
                                        error={nameErr.length > 0 ? true : false}
                                        helperText={
                                            nameErr.length > 0 ? nameErr : ''
                                        }
                                        inputProps={{ maxLength: 50 }}
                                    />
                                </Grid>
                                <Grid item lg={4} md={4} xs={12}>
                                    {/* <InputMask
                                        mask="+99 (999) 999-9999"
                                        value={state.contactNo.value}
                                        onChange={e => {
                                            regex.test(e.target.value)
                                                ? state.contactNo.set(e.target.value)
                                                : state.contactNo.set(e.target.value.trim());
                                            setPhoneErr('');
                                            checkValidPhone();
                                            handleDisableBtn();
                                        }}>
                                        {() => (
                                            <TextField
                                                size="small"
                                                fullWidth
                                                required
                                                label="Contact Number"
                                                id="outlined-basic"
                                                variant="outlined"
                                                value={state.get().contactNo}
                                                autoComplete="off"
                                                error={phoneErr.length > 0 ? true : false}
                                                helperText={phoneErr.length > 0 ? phoneErr : ''}

                                            />
                                        )}
                                    </InputMask> */}
                                    <TextField
                                        fullWidth
                                        size="small"
                                        id="outlined-basic"
                                        variant="outlined"
                                        required
                                        label="Contact Email"
                                        value={state.contactEmail.get()}
                                        autoComplete="off"
                                        onChange={(event) => {
                                            regex.test(event.target.value)
                                                ? state.contactEmail.set(event.target.value)
                                                : state.contactEmail.set(event.target.value.trim());
                                            setEmailErr('');
                                            validateEmail();
                                            handleDisableBtn();

                                        }}
                                        error={emailErr.length > 0 ? true : false}
                                        helperText={emailErr.length > 0 ? emailErr : ''}
                                        inputProps={{ maxLength: 50 }}
                                    />
                                </Grid>
                                <Grid item lg={4} md={4} xs={12}>
                                    <PhoneNumber
                                        name={'vipContact'}
                                        placeholder="Contact Number"
                                        value={state.get().contactNo}
                                        onChange={(ph) => {
                                            state.contactNo.set(ph);
                                            checkValidPhone();
                                            handleDisableBtn();
                                        }}
                                        required={true}
                                        helperText={phoneErr}
                                        error={phoneErr.length > 0 ? true : false}
                                    />
                                </Grid>

                                {/* <Grid item lg={6} md={6} xs={12}>
                                    <Box sx={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
                                        <Typography variant='subtitle2'>
                                            Would you like to opt in to photos with your family?
                                        </Typography>
                                        <FormControl error={photoErr.length > 0 ? true : false} variant="standard">
                                            <RadioGroup
                                                row
                                                sx={{ ml: 1 }}
                                                onChange={(e) => handlePhotoChange(e)}
                                                value={state.photo.get() ? 'Yes' : 'No'}
                                            >
                                                <FormControlLabel value="Yes" control={<Radio checked={state.photo.get() === 'Yes'} />} label="Yes" />
                                                <FormControlLabel value="No" control={<Radio checked={state.photo.get() === 'No'} />} label="No" />
                                            </RadioGroup>
                                            <FormHelperText>{photoErr}</FormHelperText>
                                        </FormControl>
                                    </Box>
                                </Grid> */}
                            </Grid>
                        </Box>
                        <Divider
                            light={false}
                            sx={{ mt: 2, marginRight: 0, mb: 2 }}
                            flexItem
                        />
                        <Stack
                            spacing={2}
                            direction="row-reverse"
                            sx={{ m: 1 }}>
                            {loading ? (
                                <Button
                                    variant="contained"
                                    disabled
                                    type="submit">
                                    <CircularProgress
                                        size={20}
                                        sx={{ color: 'black', position: 'absolute' }}
                                    />
                                    {state.get().VIPID > 0 && !showSaveAsDraftBtn ? (state.get().status == 1) ? 'Update & Submit' : 'Update' : 'Submit'}
                                </Button>
                            ) :
                                <Button variant="contained"
                                    //disabled={disableBtn}
                                    disabled={
                                        Helper.isAdminUser(userInfo) ||
                                            (userInfo.roles && Helper.isEventAdmin(userInfo)) ? (disableBtn === true ? true : false) : (eventInfo.readonlyOrHide === 1 ? true :
                                                modPermission === VIEW_PERMISSION ? true : disableBtn)}
                                    type="submit">
                                    {state.get().VIPID > 0 && !showSaveAsDraftBtn ? (state.get().status == 1) ? 'Update & Submit' : 'Update' : 'Submit'}
                                </Button>
                            }

                            {showSaveAsDraftBtn ? (
                                <Button
                                    variant="outlined"
                                    onClick={handleSaveAsDraft}
                                    //disabled={(disableDraftBtn || saveAsDraftLoader)}
                                    disabled={saveAsDraftLoader ||
                                        (Helper.isAdminUser(userInfo) ||
                                            (userInfo.roles && Helper.isEventAdmin(userInfo)) ? disableDraftBtn : (eventInfo.readonlyOrHide === 1 ? true :
                                                modPermission === VIEW_PERMISSION ? true : disableDraftBtn))}
                                >
                                    {
                                        saveAsDraftLoader ? <CircularProgress
                                            size={20}
                                            color="grey"
                                            style={{ position: 'absolute' }}
                                        /> : null
                                    }
                                    Save As Draft
                                </Button>
                            ) : null}

                            {Helper.isAdminUser(userInfo) ||
                                (userInfo.roles && Helper.isEventAdmin(userInfo)) ?
                                <Button variant="outlined" onClick={handleCancel}>
                                    Cancel
                                </Button> : null}
                        </Stack>

                    </Box>
                </Box>

                {snackBarProps.openSnack && (
                    <CustomizedSnackbars
                        {...snackBarProps}
                        onClose={() =>
                            setSnackBarProps({
                                ...snackBarProps,
                                openSnack: false,
                            })
                        }></CustomizedSnackbars>
                )}

                {
                    openBackdrop &&
                    <Backdrop
                        sx={{
                            color: '#fff',
                            zIndex: (theme) => theme.zIndex.drawer + 150,
                        }}
                        open={openBackdrop}
                    //onClick={handleCloseBackDrop}
                    >
                        <CircularProgress color="inherit" />
                    </Backdrop>

                }

                <RouterPrompt key='VIP'
                    when={dirty}
                    title="Leave this page"
                    cancelText="No"
                    okText="Yes"
                    onOK={handleSaveAsDraftOnPromptConfirm}
                    onCancel={handleCancelConfirmation}
                    message="There are unsaved changes. Do you want to save it?"
                />
            </Box>
        </>
    )
}
export default {
    routeProps: {
        path: [RouteConstants.CREATE_EVENT_VIP, RouteConstants.EDIT_EVENT_VIP,],
        component: CreateVipExperience,
    },
    name: 'CreateVipExperience',
}